<template>
    <div class="quality mt-4 position-relative">
        <ldc-select
            v-model="quality"
            placeholder="Chọn trạng thái"
            class="rv-select-form" v-if="$detect == 'web'">
            <ldc-option
                :value="0"
                label="Mới"/>
            <ldc-option
                :value="1"
                label="Cũ"/>
        </ldc-select>
        <ldc-select-mobile
            :showPlaceholder="false"
            placeholder="Chọn trạng thái"
            title="Trạng thái"
            v-model="quality"
            class="select-mobile-post"
            v-else>
            <ldc-option-mobile
                :value="0"
                label="Mới"/>
            <ldc-option-mobile
                :value="1"
                label="Cũ"/>
        </ldc-select-mobile>
        <div class="text-position-select position-absolute text-primary">Trạng thái</div>
    </div>
</template>
<script>
export default {
    props: ['data'],
    data() {
        return {
            quality: ''
        }
    },
    watch: {
        data(val){
            this.quality = val;
        },
        quality(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.quality = this.data;
    }
}
</script>
